<template>
	<div>
		<WNav></WNav>
		<Back></Back>
		<section class="word">
			<div class="center_box">
				<div class="toplist">
					<div class="list_item" :class="i == 0 ? 'check' : ''" @click="check(0)">{{$t('vip.personal')}}</div>
					<div class="list_item" :class="i == 1 ? 'check' : ''" @click="check(1)">{{$t('vip.Receiving')}}</div>
					<div class="list_item" :class="i == 2 ? 'check' : ''" @click="check(2)">{{$t('vip.Change')}}</div>
					<div class="list_item" :class="i == 3 ? 'check' : ''" @click="check(3)">{{$t('vip.Changezf')}}</div>
					<div class="list_item" :class="i == 4 ? 'check' : ''" @click="check(4)">{{$t('vip.billingRecord')}}</div>
				</div>
				<div class="content">
					<MemberData v-if="i == 0"></MemberData>
					<AddressList v-if="i == 1"></AddressList>
					<EditPassword v-if="i == 2"></EditPassword>
					<psd v-if="i == 3"></psd>
					<billing v-if="i == 4"></billing>
				</div>
			</div>
		</section>
		<FooterModle></FooterModle>
	</div>
</template>
<script>
	import WNav from "../assembly/WhiteNav";
	import FooterModle from "../assembly/Footer"
	import Back from "../assembly/Back"
	import MemberData from "./sub/MemberData" //个人资料
	import AddressList from "./sub/AddressList" //收货地址
	import EditPassword from "./sub/EditPassword" //修改密码
	import psd from "./sub/paymentPsd" // 修改支付密码
	import billing from "./sub/Billing" // 开票记录
	export default {
		data() {
			return {
				i: 0, //路由参数
			}
		},
		methods: {
			check(i) {
				this.i = i
			}
		},
		mounted() {
			this.i = this.$route.query.i

		},
		components: {
			WNav,
			FooterModle,
			Back,
			MemberData,
			AddressList,
			EditPassword,
			psd,
			billing
		}
	}
</script>
<style scoped>
	section {
		margin-bottom: 72px;
	}

	.center_box {
		background: #fff;
		;
	}

	.toplist {
		display: flex;
		align-items: center;
		height: 64px;
		border-bottom: 1px solid #EEEEEE;
		padding-left: 33px;
	}

	.list_item {
		height: 100%;
		line-height: 64px;
		font-size: 16px;
		margin-right: 64px;
		color: #666666;
	}

	.list_item.check {
		border-bottom: 1px solid #000000;
		color: #131313;
	}

	.content {
		height: 700px;
		background: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/MemberCenterDetail.vue